import React from "react";
import { FaBolt } from "react-icons/fa6";
import "swiper/css";
import appointshape from "../../../assets/images/appoint-shape.png";

const Contact = () => {
  //     const contactCards = [
  //     {
  //       icon: <FiPhone />,
  //       title: "Contact Sale",
  //       desc: "Speak to someone from our sales team.",
  //       button: "Contact Sales",
  //     },
  //     {
  //       icon: <FaRegCircleQuestion />,
  //       title: "Have a Question",
  //       desc: "See our frequently asked question",
  //       button: "Get Answers",
  //     },
  //     {
  //       icon: <RiFolderCheckLine />,
  //       title: "Press & Media",
  //       desc: "Get in touch with our PR team",
  //       button: "Press Contact",
  //     },
  //   ];

  return (
    <div>
      <section className="pt-28 pb-0 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="relative bg-[#f2f4f7] p-4 lg:p-12 md:p-12 rounded-2xl z-10">
            <div className="absolute top-0 right-0 z-0">
              <img src={appointshape} alt="shape" />
            </div>

            <div className="flex flex-wrap justify-between items-center gap-y-6 mb-14 pb-10 border-b-2 border-white relative z-10">
              <div className="max-w-2xl">
                <h4 className="text-gray-800 text-sm flex items-center gap-2">
                  <div className="bg-white border-2 flex py-1.5 px-4 gap-3 items-center rounded-full">
                    <span className="text-teal-600">
                      <FaBolt className="bg-teal-600 bg-opacity-20 rounded-full p-1 w-6 h-6" />
                    </span>
                    Contact Our Support Team
                  </div>
                </h4>
                <h2 className="text-3xl md:text-4xl text-start font-bold mt-4">
                  Need help with your orders <br /> or B2B connections?
                </h2>
                <p className="mt-6 text-gray-700 text-start">
                  Our dedicated support team is here to assist you with order
                  tracking, buyer-seller requests, distributor management, and
                  any technical issues you may face on the portal. <br />
                  Connect with us today to ensure your business runs smoothly
                  and without delays.
                </p>
              </div>
            </div>

            <form className="relative z-10 mt-10 bg-white p-8 rounded-lg">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-7">
                <label className="block text-sm text-gray-700 text-start">
                  Full Name
                  <input
                    type="text"
                    placeholder="Full Name"
                    className="border border-gray-300 font-normal rounded-md px-4 py-2 w-full outline-none mt-2"
                  />
                </label>

                <label className="block text-sm text-gray-700 text-start">
                  Email
                  <input
                    type="email"
                    placeholder="Email"
                    className="border border-gray-300 font-normal rounded-md px-4 py-2 w-full outline-none mt-2"
                  />
                </label>
                <label className="block text-sm text-gray-700 text-start">
                  Mobile
                  <input
                    type="number"
                    placeholder="Mobile"
                    className="border border-gray-300 font-normal rounded-md px-4 py-2 w-full outline-none mt-2"
                  />
                </label>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-7">
                <label className="block text-sm text-gray-700 text-start">
                  Company *
                  <input
                    type="text"
                    placeholder="Company *"
                    className="border border-gray-300 font-normal rounded-md px-4 py-2 w-full outline-none mt-2"
                  />
                </label>

                <label className="block text-sm text-gray-700 text-start">
                  Subject *
                  <input
                    type="text"
                    placeholder="Subject *"
                    className="border border-gray-300 font-normal rounded-md px-4 py-2 w-full outline-none mt-2"
                  />
                </label>
              </div>
              
              <div className="mb-6">
                <label className="block text-sm text-gray-700 text-start">
                  Any Message You Want to Share With Us*
                  <textarea
                    rows="5"
                    placeholder="Any Message You Want to Share With Us*"
                    className="border border-gray-300 font-normal rounded-md px-4 py-2 w-full outline-none mt-2"
                  ></textarea>
                </label>
              </div>

              <button
                type="submit"
                className="w-full bg-[#1a9588] text-white hover:shadow-xl px-6 py-2 rounded-md hover:bg-[#28b5a6] transition font-semibold"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
